import { createFormContext } from '@mantine/form'

export const [SummaryFormProvider, useSummaryFormContext, useSummaryForm] = createFormContext()